import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import useApi from "../../../../Utils/BackendClient";
import { Toast } from "primereact/toast";
import { formatDate, useEnumLabel } from "../../../../Utils/Utils";
import { Button } from "primereact/button";
import { Translate } from "../../../../Utils/TranslationUtils";
import useGetEnums from "../../../../Utils/EnumsUtils";
import EnumsContext from "../../../../context/enums-context";

const ReportsArchive = () => {

    const ctx = useContext(EnumsContext);
    const toast = useRef();

    const enumTypes = useMemo(() => ["divisions"], []);

    useGetEnums(enumTypes);
    
    const getDivisionLabel = useEnumLabel(ctx.enums.divisions.data);


    const { downloadReport, fetchGeneratedReports } = useApi();

    const [generatedReports, setGeneratedReports] = useState(null);
    const [lazyState, setlazyState] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: "created_at",
        sortOrder: 1,
    });
    const [totalRecords, setTotalRecords] = useState(0);

    useEffect(() => {
            const fetchData = async () => {

                const response = await fetchGeneratedReports(lazyState);
    
                if (response.status === 200) {
                    setTotalRecords(response.data.count);
                    setGeneratedReports(response.data.results);

                    console.log(response.data.results);
                }
                else {
                    toast.current.show({ severity: "error", summary: "Помилка завантаження списку актів", detail: "Помилка сервера " + response.status, life: 3000 });
    
                    setGeneratedReports([]);
                }
            }
    
            fetchData();
    
    }, [fetchGeneratedReports, lazyState]);

    const onPage = (event) => {
        event.page = event.page + 1;
        setlazyState(event);
    };

    const onSort = (event) => {
        event.page = lazyState.page;
        setlazyState(event);
    }

    const downloadXlsReport = async (key) => {

        const response = await downloadReport(key);

        console.log(response);
        if (response.status === 200) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            console.log(url);

            const link = document.createElement('a');
            link.href = url;

            link.download = `${key}.xlsx`;
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.remove();
            window.URL.revokeObjectURL(url);

            toast.current.show({ severity: 'success', summary: 'Створення документу', detail: 'Документ створено', life: 3000 });
        }
    }

    const renderFilters = (obj) => {
        if (!obj) return "-";

        return (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                    <tr>
                        <td style={{ padding: "2px 4px" }}>{`Період: ${obj.start_date}/${obj.end_date}`}</td>
                    </tr>
                    {obj.division_id && <tr>
                        <td style={{ padding: "2px 4px" }}>{`Точка продажу: ${getDivisionLabel(obj.division_id)}`}</td>
                    </tr>}
                </tbody>
            </table>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (<div className="flex flex-wrap gap-2">
            <Button
                size="small"
                icon="pi pi-download"
                severity="secondary"
                outlined
                onClick={(event) => downloadXlsReport(rowData.redis_key)}
            />
        </div>
        )
    }

    return (<>
        <Toast ref={toast} />
        <DataTable value={generatedReports} lazy rows={lazyState.rows} paginator onPage={onPage} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]} first={lazyState.first}
            onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder} >
            <Column field="report_type" header="Тип звіту" body={(rowData) => Translate(rowData.report_type)}/>
            <Column field="created_at" header="Дата" body={(rowData) => formatDate(rowData.created_at)} sortable/>
            <Column field="created_by" header="Користувач"/>
            <Column field="filters" header="Фільтри" body={(rowData) => renderFilters(rowData.filters)}/>
            <Column field="action" body={(rowData) => actionBodyTemplate(rowData)} />
        </DataTable>
    </>)
};

export default ReportsArchive;